import Header from "@/components/Header";
import Footer from "@/components/Footer";

const PoliticaPrivacidad = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto max-w-3xl px-4 py-32">
        <h1 className="font-display text-3xl font-bold sm:text-4xl">Política de Privacidad</h1>

        <section className="mt-8 space-y-4 text-muted-foreground">
          <h2 className="text-xl font-semibold text-foreground">1. Responsable del tratamiento</h2>
          <p>
            El responsable del tratamiento de sus datos personales es <strong className="text-foreground">Null Guard</strong>,
            con correo electrónico de contacto: <a href="mailto:info@nullguard.xyz" className="text-primary hover:underline">info@nullguard.xyz</a>.
          </p>

          <h2 className="text-xl font-semibold text-foreground">2. Datos que recopilamos</h2>
          <p>Recopilamos los datos personales que usted nos proporciona voluntariamente a través de nuestros formularios de contacto:</p>
          <ul className="list-inside list-disc space-y-1">
            <li>Nombre</li>
            <li>Dirección de correo electrónico profesional</li>
            <li>Nombre de la empresa</li>
            <li>Número aproximado de empleados</li>
          </ul>

          <h2 className="text-xl font-semibold text-foreground">3. Finalidad del tratamiento</h2>
          <p>Los datos recopilados serán utilizados exclusivamente para:</p>
          <ul className="list-inside list-disc space-y-1">
            <li>Gestionar su solicitud de demostración gratuita</li>
            <li>Contactarle para agendar la demo solicitada</li>
            <li>Enviarle información comercial relacionada con nuestros servicios, solo si nos ha dado su consentimiento</li>
          </ul>

          <h2 className="text-xl font-semibold text-foreground">4. Base legal</h2>
          <p>
            El tratamiento de sus datos se fundamenta en el consentimiento que usted otorga al completar el
            formulario de contacto, de conformidad con el artículo 6.1.a) del Reglamento General de Protección
            de Datos (RGPD).
          </p>

          <h2 className="text-xl font-semibold text-foreground">5. Conservación de los datos</h2>
          <p>
            Sus datos personales serán conservados mientras sea necesario para la finalidad para la que fueron
            recogidos. Una vez finalizada dicha relación, los datos serán suprimidos o bloqueados conforme a la
            normativa aplicable.
          </p>

          <h2 className="text-xl font-semibold text-foreground">6. Derechos del interesado</h2>
          <p>Usted tiene derecho a:</p>
          <ul className="list-inside list-disc space-y-1">
            <li>Acceder a sus datos personales</li>
            <li>Rectificar datos inexactos o incompletos</li>
            <li>Solicitar la supresión de sus datos</li>
            <li>Oponerse al tratamiento de sus datos</li>
            <li>Solicitar la limitación del tratamiento</li>
            <li>Solicitar la portabilidad de sus datos</li>
          </ul>
          <p>
            Para ejercer estos derechos, puede dirigirse a{" "}
            <a href="mailto:info@nullguard.xyz" className="text-primary hover:underline">info@nullguard.xyz</a>.
          </p>
          <p>
            También puede gestionar sus preferencias de datos y solicitar la eliminación de su información a través de nuestro{" "}
            <a href="https://na1.hs-data-privacy.com/request/x8HfKQs-SJX0ilZCdnf2wg" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
              portal de gestión de privacidad de datos
            </a>.
          </p>

          <h2 className="text-xl font-semibold text-foreground">7. Cookies y herramientas de analítica</h2>
          <p>
            Este sitio web utiliza cookies propias y de terceros. Para más información, consulte nuestro banner de
            consentimiento de cookies que aparece al acceder al sitio.
          </p>
          <p>
            Si usted otorga su consentimiento para cookies analíticas, utilizamos las siguientes herramientas de terceros
            para analizar el uso del sitio web y mejorar nuestros servicios:
          </p>
          <ul className="list-inside list-disc space-y-1">
            <li><strong className="text-foreground">Google Analytics 4</strong> — servicio de análisis web proporcionado por Google LLC. <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Política de privacidad de Google</a>.</li>
            <li><strong className="text-foreground">PostHog</strong> — plataforma de analítica de producto con datos alojados en la Unión Europea (eu.posthog.com). <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Política de privacidad de PostHog</a>.</li>
          </ul>
          <p>
            Estas herramientas solo se activan si usted acepta las cookies analíticas a través de nuestro banner de consentimiento.
            Puede revocar su consentimiento en cualquier momento eliminando las cookies de su navegador.
          </p>

          <h2 className="text-xl font-semibold text-foreground">8. Modificaciones</h2>
          <p>
            Null Guard se reserva el derecho de modificar esta Política de Privacidad en cualquier momento. Las
            modificaciones serán publicadas en esta misma página.
          </p>
        </section>

        <nav aria-label="Otras páginas legales" className="mt-12 flex flex-wrap gap-4 border-t border-border pt-8 text-sm">
          <a href="/aviso-legal" className="text-primary hover:underline">Aviso legal</a>
          <a href="/accesibilidad" className="text-primary hover:underline">Declaración de accesibilidad</a>
        </nav>
      </main>
      <Footer />
    </div>
  );
};

export default PoliticaPrivacidad;
